var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row",
    attrs: {
      "id": "specialCamps"
    }
  }, [_c('div', {
    staticClass: "card text-center col-sm-12"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v("Special Health Camps")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "card-text"
  }, [_vm._v("We run special health camps quite often as an outreach to the sick and needy who aren't able to make it to our health centres. These are on going camps as part of our Urban Primary health Centres Project. We run 14 of these camps per month in different\n        areas in Roorkee.\n      ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-warning btn-md showGallery",
    on: {
      "click": _vm.visibleGallery
    }
  }, [_vm._v("Show Gallery")])]), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "animated slideInUp",
      "leave-active-class": "animated fadeOutDown",
      "appear": ""
    }
  }, [(_vm.showGallery) ? _c('div', {
    staticClass: "card-footer"
  }, [_c('button', {
    staticClass: "btn btn-danger btn-lg",
    attrs: {
      "id": "first-close-btn"
    },
    on: {
      "click": _vm.hideGallery
    }
  }, [_c('i', {
    staticClass: "fa fa-window-close",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "row gallery"
  }, [_vm._l((_vm.fileTitles), function(file) {
    return _c('div', {
      key: file.name,
      staticClass: "col-md-4 col-sm-6"
    }, [_c('a', {
      staticClass: "lightbox",
      attrs: {
        "href": require(("./Camps-pics/" + (file.name)))
      }
    }, [_c('img', {
      staticClass: "img-responsive rounded",
      attrs: {
        "src": require(("./Camps-pics/" + (file.name))),
        "alt": file.alt
      }
    })])])
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger btn-lg",
    attrs: {
      "id": "second-btn"
    },
    on: {
      "click": _vm.hideGallery
    }
  }, [_c('i', {
    staticClass: "fa fa-window-close",
    attrs: {
      "aria-hidden": "true"
    }
  })])], 2)]) : _vm._e()])], 1)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4e889f0f","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Events/SpecialCamps/SpecialCamps.vue
// module id = M8Mp
// module chunks = 0